import { UnhandledInReportingError } from '../../../error'
import type { Answer, AnswerBase } from '../answer'

/**
 * ラベル検査の回答の型
 */
export type LabelCheckAnswer = AnswerBase<'labelCheck'> & {
  /**
   * 逸脱フラグ
   */
  isInvalid: boolean

  /**
   * ラベル検査結果ID
   */
  reportLabelInspectionId: string

  /**
   * 検査したラベルの数
   */
  numberOfLabels: number

  /**
   * 検査したラベルのIDのリスト。互換性のためオプショナルにしているが、基本的には値がセットされている。
   * numberOfLabelsはこのリストの長さを表す。
   */
  inspectedLabelIds?: string[]
}

const isLabelCheckAnswer = (
  answer: Answer | undefined,
): answer is LabelCheckAnswer => {
  return answer?.type === 'labelCheck'
}

type RequireLabelCheckAnswer = (
  answer: Answer | undefined,
) => asserts answer is LabelCheckAnswer
export const requireLabelCheckAnswer: RequireLabelCheckAnswer = answer => {
  if (!isLabelCheckAnswer(answer)) {
    throw new UnhandledInReportingError(
      `The answer is not a label check answer.`,
      {
        answer,
      },
    )
  }
}

type CreateAnswerInput = {
  isInvalid?: boolean
  reportLabelInspectionId: string
  numberOfLabels?: number
  inspectedLabelIds?: string[]
}

const createAnswer = ({
  isInvalid = false,
  reportLabelInspectionId,
  numberOfLabels = 0,
  inspectedLabelIds = [],
}: CreateAnswerInput): LabelCheckAnswer => {
  return {
    recordedAt: new Date(),
    type: 'labelCheck',
    isInvalid,
    reportLabelInspectionId,
    numberOfLabels,
    inspectedLabelIds,
  }
}

const toInvalid = (answer: LabelCheckAnswer): LabelCheckAnswer => {
  return {
    ...answer,
    isInvalid: true,
  }
}

const toValid = (answer: LabelCheckAnswer): LabelCheckAnswer => {
  return {
    ...answer,
    isInvalid: false,
  }
}

export const LabelCheckAnswer = {
  isLabelCheckAnswer,
  createAnswer,
  toInvalid,
  toValid,
}
